import { render, staticRenderFns } from "./CarouselResponsiveBreakpoints.vue?vue&type=template&id=8f0c2f24&"
import script from "./CarouselResponsiveBreakpoints.vue?vue&type=script&lang=js&"
export * from "./CarouselResponsiveBreakpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports